import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import {
  Header,
  HeaderButton,
  ListItemLabel,
  Shell,
  ViewPort,
} from "bossfotos-design-system";
import {
  isWindowInIframe,
  setGalleryNavBackButtonUrl,
} from "../../v2_actions/nav";
import head from "lodash/head";
import { BOSSFOTOS_INFO_WEBSITE } from "../../v2_actions/routes";
import ContextMenu from "../../v2_components/layout/ContextMenu";
import DesktopEventList from "../../v2_components/eventpage/DesktopEventList";
import { NavBar } from "./NavBar";
import CollectionsIcon from "@mui/icons-material/Collections";
import PlaceIcon from "@material-ui/icons/Place";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import { makeLogger } from "../../utils/o11y/logger";
import styles from "./Events.module.css";
import { albumListForEventTab } from "../../v2_actions/customer_album";
import { briefGalleryList } from "../../v2_actions/brief_gallery";
import { briefGalleryEventList } from "../../v2_actions/brief_gallery_event";
import { photographerList } from "../../v2_actions/photographer";
import { useEventsPageStartupEffects } from "../../v2_components/hooks/useEventsPageStartupEffects";
import { useReduxStateReconcilation } from "../../v2_components/hooks/useReduxStateReconcilation";
import { useEventFiltersDispatcher } from "../../v2_components/hooks/useEventFiltersDispatcher";
import { useRouteInfo } from "../../v2_components/hooks/useRouteInfo";

const GALLERY_EVENT_PAGE_SIZE = 72;
const BRIEF_GALLERY_PAGE_SIZE = 24;

const logger = makeLogger({
  enabled: true,
  label: "MobileEvents",
  color: "red",
});

const MobilePhotographerEvents = () => {
  const isInIframe = isWindowInIframe();
  const dispatch = useDispatch();
  useReduxStateReconcilation();
  const eventPageCtx = useEventFiltersDispatcher();
  const { country, photographerNickName } = useParams();
  const [showContextMenu, setShowContextMenu] = useState(false);
  const photographer: {
    last_name?: string
  } = useSelector(() => head(photographerList.getVisibleObjects())) ?? {};

  setGalleryNavBackButtonUrl();

  const handleMenuClicked = () => {
    setShowContextMenu(true);
  };

  const handleHelpClicked = () => {
    window.open(`${BOSSFOTOS_INFO_WEBSITE}/info-centre/`);
  };

  useEffect(() => {
    dispatch(
      briefGalleryEventList.updatePaginationNumItemsPerPage(GALLERY_EVENT_PAGE_SIZE),
    );
    dispatch(
      briefGalleryList.updatePaginationNumItemsPerPage(BRIEF_GALLERY_PAGE_SIZE),
    );
  },[])

  useEffect(() => {
      const baseFilter = {
      gallery_type: undefined,
      gallery_event: undefined,
      gallery_event_name: undefined,
      album: undefined,
      has_gallery_event: true,
      any_field: undefined,
      activity_tags: undefined,
      shot_at_date_from: undefined,
      shot_at_date_to: undefined,
      photographers: photographerNickName,
      country: country,
      private_event_token: '',
      public_or_direct_url: '',
      exclude_galleries_with_an_album: true,
    }

    eventPageCtx.updateBriefGalleryFilter({
      ...baseFilter,
    }, { skipGalleryEventFetch: true });

    dispatch(briefGalleryEventList.updateListFilter({
      photographers: photographerNickName,
      country: country,
    }));
    dispatch(briefGalleryEventList.fetchListIfNeeded({
      callSource: "MobilePhotographerEvents_briefGalleryEvent",
      forceUpdate: true,
    }));

    dispatch(photographerList.updateListFilter({name_used: photographerNickName}))
    dispatch(photographerList.fetchListIfNeeded())
    
  },[country, photographerNickName])
  
  return (
    <ViewPort>
      <Shell>
        <ContextMenu
          showContextMenu={showContextMenu}
          setShowContextMenu={setShowContextMenu}
        />
        {!isInIframe && (
          <NavBar
            onMenuClicked={handleMenuClicked}
            onHelpClicked={handleHelpClicked}
            photographerNickName={photographer.last_name || photographerNickName}
          />
        )}
        <div className={`${styles.padded}`}></div>
        <div
          data-testid="legacy-mobile-eventlist-wrapper"
          className={`${styles.legacymobileeventlistwrapper} legacymobileeventlistwrapper`}
        >
          <DesktopEventList
            gallery_event_name={undefined}
            album_name={undefined}
            photographerMode={true}
          />
        </div>
      </Shell>
    </ViewPort>
  );
};

export default MobilePhotographerEvents;
